import React from 'react';

import { IconProps } from './types';

export const WatchIconGray = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    viewBox="0 0 20 21.72"
    ref={forwardedRef}
    {...props}
  >
    <g id="watch_icons-03" data-name="watch icons-03" transform="translate(-60.546 -45.31)">
      <path
        id="Path_563"
        data-name="Path 563"
        d="M62.206,51.661a8.467,8.467,0,0,1,5.087-3.589.522.522,0,0,0,.324-.784A3.832,3.832,0,1,0,61.36,51.7a.522.522,0,0,0,.846-.039Z"
        transform="translate(0 -0.178)"
        fill="#909090"
      />
      <path
        id="Path_564"
        data-name="Path 564"
        d="M214.321,45.31a3.822,3.822,0,0,0-3.239,1.786.521.521,0,0,0,.324.786,8.468,8.468,0,0,1,5.11,3.562.522.522,0,0,0,.848.03,3.83,3.83,0,0,0-3.043-6.165Z"
        transform="translate(-137.612)"
        fill="#909090"
      />
      <path
        id="Path_565"
        data-name="Path 565"
        d="M85.172,99.2a9.3,9.3,0,1,0-13.265,0l-.7.987a1.116,1.116,0,1,0,1.817,1.3l.623-.879a9.287,9.287,0,0,0,9.787,0l.622.879a1.116,1.116,0,1,0,1.818-1.3ZM70.749,92.673a7.789,7.789,0,1,1,7.789,7.812A7.8,7.8,0,0,1,70.749,92.673Z"
        transform="translate(-8 -34.965)"
        fill="#909090"
      />
      <path
        id="Path_566"
        data-name="Path 566"
        d="M124.332,153.2a.759.759,0,0,1-.536-.222l-2.678-2.678a.758.758,0,1,1,1.071-1.072l2.143,2.143,4.821-4.821a.758.758,0,1,1,1.071,1.071l-5.353,5.357A.759.759,0,0,1,124.332,153.2Z"
        transform="translate(-55.132 -92.405)"
        fill="#909090"
      />
    </g>
  </svg>
));
WatchIconGray.displayName = 'WatchIconGray';

export default WatchIconGray;
